module.exports = __webpack_public_path__ + "static/media/pic-book-main-img2.a64240de.jpg";